var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 10,
    viewBox: "0 0 5 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.10526 5.03973V9.87469C1.10526 9.94499 1.16447 10 1.24013 10H3.17105C3.24671 10 3.30592 9.94499 3.30592 9.87469V4.96027H4.70724C4.77632 4.96027 4.83553 4.91137 4.84211 4.84413L4.97698 3.36491C4.98356 3.29156 4.92106 3.22738 4.84211 3.22738H3.30592V2.17604C3.30592 1.92848 3.51974 1.72983 3.78619 1.72983H4.86514C4.9408 1.72983 5 1.67482 5 1.60452V0.125302C5 0.0550087 4.9408 0 4.86514 0H3.03947C1.97039 0 1.10198 0.806846 1.10198 1.80012V3.22738H0.13487C0.0592118 3.22738 0 3.2824 0 3.35269V4.83191C0 4.9022 0.0592118 4.95721 0.13487 4.95721H1.10198V5.03667L1.10526 5.03973Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.84890691c27fc6a33c08fd675d8dc6ff.svg";
export { ForwardRef as ReactComponent };